var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "big-data"
  }, [_c("a-spin", {
    attrs: {
      tip: "跳转中...",
      spinning: true
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };